import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class WinterHoardGameMode extends GameMode{
    public static readonly FREESPIN_TRANSFORM:string = "FREESPIN_TRANSFORM";
    public static readonly FREESPIN_MULTIPLIER:string = "FREESPIN_MULTIPLIER";
    public static readonly FREESPIN_COMBINED:string = "FREESPIN_COMBINED";
    public static readonly FREESPIN_COUNTER:string = "FREESPIN_COUNTER";
    public static readonly FREESPIN_PICK:string = "FREESPIN_PICK";
}